/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

/* eslint-disable global-require */

// The top-level (parent) route
const routes = {
  path: '',

  // Keep in mind, routes are evaluated in order
  children: [
    {
      path: '',
      load: () => import(/* webpackChunkName: 'home' */ './home'),
    },
    {
      path: '/news',
      load: () => import(/* webpackChunkName: 'blog' */ './blog'),
    },
    {
      path: '/documents',
      load: () => import(/* webpackChunkName: 'documents' */ './documents'),
    },
    {
      path: '/document/:document_uid',
      load: () => import(/* webpackChunkName: 'document' */ './document'),
    },
    {
      path: '/news/:news_uid',
      load: () => import(/* webpackChunkName: 'news' */ './news'),
    },
    {
      path: '/about',
      load: () => import(/* webpackChunkName: 'about' */ './about'),
      // action() {
      //   const resp = await fetch('/api/tasks');
      //   const data = await resp.json();
      //   return data && {
      //     title: `To-do (${data.length})`,
      //     component: <TodoList {...data} />
      //   };
      // }
    },
    {
      path: '/preview',
      load: () => import(/* webpackChunkName: 'preview' */ './preview'),
    },

    // Wildcard routes, e.g. { path: '(.*)', ... } (must go last)
    {
      path: '(.*)',
      load: () => import(/* webpackChunkName: 'not-found' */ './not-found'),
    },
  ],

  async action({ next }) {
    // Execute each child route until one of them return the result
    const route = await next();

    // Provide default values for title, description etc.
    route.title = `${route.title || 'Untitled Page'} - Right to Water`;
    route.description =
      route.description ||
      'Right to water is an European citizens initiative launched to ensure that water remains a public service and a public good.';

    return route;
  },
};

// The error page is available by permanent url for development mode
if (__DEV__) {
  routes.children.unshift({
    path: '/error',
    action: require('./error').default,
  });
}

export default routes;
